import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const Layout = lazy(() => import("./Pages/Layout"));
const MainPage = lazy(() => import("./Pages/Main"));
const DetailPage = lazy(() => import("./Pages/Main/Content/Detail"));
const Summary = lazy(() => import("./Pages/Main/Content/Detail/Summary"));
export const authorizationDocumentRoutes = [
  {
    path: pathRoutes.authorizationDocument.parameter,
    page: Layout,
    screenCode: SCREEN.IP_014,

    children: [
      {
        path: "",
        page: MainPage,
      },
      {
        path: pathRoutes.authorizationDocument.detail.parameter,
        page: DetailPage,
        children: [
          {
            path: ":content",
            page: Summary,
          },
        ],
      },
    ],
  },
];
